<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import ParameterGrid from './components/ParameterGrid.vue'
  import { getLayoutByModel } from './utils/layouts'
  import { useParameters } from '../composables/useParameters'
  import { useSkeletonHold } from '../composables/useSkeletonHold'

  // TODO: 后续从 deviceStore / manifest 获取真实型号
  // const currentModel = 'VT-SE'
  // const layout = getLayoutByModel(currentModel)
  const layout = getLayoutByModel()
  const parameters = useParameters()
  const showSkeleton = computed(
    () => parameters.state.phase.value === 'cold' && parameters.state.isReading.value,
  )
  const skeletonVisible = useSkeletonHold(showSkeleton)

  // 每次进入页面重新拉取最新参数
  onMounted(() => {
    parameters.actions.refresh()
  })
</script>

<template>
  <div class="py-2 px-12 max-w-360 m-auto w-full">
    <Transition
      mode="out-in"
      enter-active-class="animate-in fade-in zoom-in-99 duration-200"
      leave-active-class="animate-out fade-out zoom-out-99 duration-200"
    >
      <ParameterGrid
        v-if="skeletonVisible"
        key="skeleton"
        :layout="layout"
        :parameters="parameters"
        placeholder
      />
      <div
        v-else-if="parameters.state.phase.value === 'error'"
        key="error"
        class="flex h-40 items-center justify-center text-m-medium text-text-glass-default"
      >
        {{ $t('parameters.loadFailed') }}
      </div>
      <ParameterGrid v-else key="content" :layout="layout" :parameters="parameters" />
    </Transition>
  </div>
</template>
